module.exports = __webpack_public_path__ + "img/23_33.c9a3acff.png";